import { applicationID, relationId } from "../../../../api/ApplicationID";
import { httpRequest } from "../../../../functions";
import { useCallback } from "react";
import { messages } from "../constants";

export function usePasswordChange(
  pwd,
  setPwd,
  setPwdModal,
  setPwdError,
  setPwdSubmitting,
  requestsApi,
  notify
) {
  const handleSubmitPassword = useCallback(async () => {
    const appId = applicationID;
    const relId = relationId;

    if (!pwd.current || !pwd.next || !pwd.confirm) {
      setPwdError(messages.pwdRequired);
      return;
    }
    if (pwd.next !== pwd.confirm) {
      setPwdError(messages.pwdMismatch);
      return;
    }

    setPwdSubmitting(true);
    setPwdError("");

    try {
      const recordResponse = await httpRequest(
        "POST",
        requestsApi.getDataEntity,
        requestsApi.basicAuth,
        {
          entityName: "_securityuser",
          fieldName: "_relationid",
          expressao: relId,
          applicationId: appId,
          relationId: relId,
        }
      );

      const resultDataEntityJsonRecords =
        JSON.parse(recordResponse)?.masterEntity?.[0]?.records[0];

      if (!resultDataEntityJsonRecords) {
        throw new Error("Usuário não encontrado.");
      }

      if (
        String(pwd.current) !==
        String(resultDataEntityJsonRecords._cryptpassword)
      ) {
        throw new Error(messages.pwdCurrentIncorrect);
      }

      if (
        String(pwd.next) === String(resultDataEntityJsonRecords._cryptpassword)
      ) {
        throw new Error(messages.pwdSameAsCurrent);
      }

      const ok = await httpRequest(
        "POST",
        requestsApi.utilService,
        requestsApi.basicAuth,
        {
          senhaAtual: pwd.current,
          senhaNova: pwd.next,
          relationId: relId,
        }
      );

      if (!ok) throw new Error(messages.pwdGenericError);

      setPwdModal({ isVisible: false });
      setPwd({ current: "", next: "", confirm: "" });
      notify(messages.pwdSuccess, "success", 3000);
    } catch (err) {
      notify(messages.pwdGenericError, "error", 3000);
      setPwdError(err?.message || messages.pwdGenericError);
      setPwd({ current: "", next: "", confirm: "" });
    } finally {
      setPwdSubmitting(false);
      setPwd({ current: "", next: "", confirm: "" });
    }
  }, [pwd, applicationID, relationId]);

  return handleSubmitPassword;
}
